import { updateCompanyConfigSettings } from "../../infrastructure/repository/company-repository";
import { showSuccessMessage } from "../commons/show-success-message";
import { showErrorMessage } from "../commons/show-error-message";
import { logError } from "../../infrastructure/log";
import { translate } from "../../infrastructure/translate/localization";

export async function saveAlertConfigSettings(
  autoCloseDay,
  adjustmentEmailSubscribers
) {
  try {
    const configSettings = {
      autoCloseDay,
      adjustmentEmailSubscribers,
    };
    updateCompanyConfigSettings({ configSettings });
    showSuccessMessage(translate("common-messages.basic-success-message"));
  } catch (e) {
    logError(
      e,
      `Error to updateCompanyConfigSettings with close day ${autoCloseDay}`
    );
    showErrorMessage(translate("common-messages.basic-error-message"), true);
  }
}
